import { render } from "./CreateDatabase.vue?vue&type=template&id=35f60990"
import script from "./CreateDatabase.vue?vue&type=script&lang=js"
export * from "./CreateDatabase.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__